import * as THREE from 'three'
import settings from '../../config/Settings'
import constants from '../../config/Constants'
import sunData from '../../config/SunData'
import utils from '../../utils'
import labelFactory from '../../LabelFactory'

class Sun {
  constructor() {
    this.three = {
      sun: this.createSun(),
    }
  }

  // return THREE.Group of Sun object
  createSun() {
    var sunMaterial	= new THREE.MeshBasicMaterial({map: new THREE.TextureLoader().load(settings.imgDir + 'sunmap.jpg')})
    var sun = utils.createSphere(sunData.radius, sunMaterial)

    var sunSprite = new THREE.Sprite(new THREE.SpriteMaterial({
      map: new THREE.TextureLoader().load(settings.imgDir + 'sunsprite.png'),
      blending: THREE.AdditiveBlending,
      color: 0xffffff,
    }))
    sunSprite.scale.x = 2000 * constants.UD
    sunSprite.scale.y = 2000 * constants.UD
    sunSprite.scale.z = 1

    var label = labelFactory.createLabel('sun', 'Sol')

    var group = new THREE.Group()
    group.type = 'sun'
    group.description = sunData.description
    group.descriptionImage = sunData.descriptionImage
    group.descriptionSource = sunData.descriptionSource
    group.mainObject = sun
    group.label = label
    group.add(sun)
    group.add(label)
    group.add(sunSprite)
    
    return group
  }

  getLabel() {
    return this.three.sun.label
  }

  updateLabelPosition(cameraPosition) {
    const sunPos = this.three.sun.mainObject.position
    const distanceToSun = cameraPosition.distanceTo(sunPos)

    const deltaX = cameraPosition.x
    const deltaY = cameraPosition.y
    const deltaZ = cameraPosition.z

    let cosTeta = deltaY / distanceToSun
    let sinTeta = Math.pow((1 - Math.pow(cosTeta, 2)), (1/2)) // (plus or minus)
    let tanTeta = Math.pow((1 - Math.pow(cosTeta, 2)), (1/2)) / cosTeta // (plus or minus)

    let newY = sinTeta * 180

    let planeDiagonal = deltaY * tanTeta
    let newPlaneDiagonal = newY / tanTeta

    let newZ = (deltaZ * newPlaneDiagonal) / planeDiagonal
    let newX = (deltaX * newPlaneDiagonal) / planeDiagonal

    this.three.sun.label.position.set(-newX, newY, -newZ)
  }
}

export default Sun